module.exports = __webpack_public_path__ + "img/sitemap-clouds.2c2b4bb4.png";